'use client';

import { useEffect, useRef } from 'react';

import { trackMetaConversion } from '@/lib/analytics';
import { track, AnalyticsEvent } from '@/lib/analytics/tracker';

type OfferingView = {
  type: 'class' | 'class_pack' | 'subscription' | 'gift_card';
  id: string | undefined;
  slug: string;
  name: string;
  price: number | null;
  currency: string | null;
};

export const useProductViewTracking = (offering: OfferingView) => {
  const firedRef = useRef(false);

  useEffect(() => {
    if (!offering.id || firedRef.current) return;
    firedRef.current = true;

    trackMetaConversion({
      event: 'ViewContent',
      custom_data: {
        content_name: offering.name,
        content_type: offering.type,
        content_ids: [offering.slug],
        value: offering.price ?? 0,
        ...(offering.currency && { currency: offering.currency }),
      },
    });
    track({
      event: AnalyticsEvent.PRODUCT_VIEWED,
      properties: {
        product_type: offering.type,
        product_name: offering.name,
        product_id: offering.id,
        product_slug: offering.slug,
        price: offering.price,
        currency: offering.currency,
      },
    });
  }, [offering.id]);
};
